import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';
import BusTransactionListContainer from '../containers/BusTransactionListContainer';

function getBusTransactionListScreenTitle(isReservation) {
  return isReservation
    ? 'Daftar Pesanan Belum Dibayar'
    : 'Data Penjualan Tiket';
}

const BusTransactionListSwiper = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusTransactionListSwiper" */ '../components/BusTransactionListSwiper'),
  loading: DefaultLoadingScreen,
});

const BusTransactionListScreen = props => {
  const isReservationListParam = props.navigation.getParam(
    'isReservationList',
    false
  );
  const isReservationList =
    isReservationListParam === 'true' || isReservationListParam === true;

  if (isReservationList) {
    return <BusTransactionListContainer {...props} />;
  }

  return <BusTransactionListSwiper {...props} />;
};

BusTransactionListScreen.navigationOptions = props => {
  const isReservationListParam = props.navigation.getParam(
    'isReservationList',
    false
  );
  const isReservationList =
    isReservationListParam === 'true' || isReservationListParam === true;

  return {
    headerTitle: (
      <HeaderOneLine
        title={getBusTransactionListScreenTitle(isReservationList)}
      />
    ),
  };
};

export default BusTransactionListScreen;
